module.exports = __webpack_public_path__ + "static/media/login_image_1.68f8782e.jpg";